import { menuAnatomy as parts } from '@chakra-ui/anatomy';
import { mode } from '@chakra-ui/theme-tools';
import { getCSSVar } from '@chakra-ui/utils';

var variantDefault = props => {
  var value = getCSSVar(props.theme, 'colors', 'brand.500');
  console.log('🦑 Menu props.theme', props.theme);
  return {
    arrow: {
      bg: value
    },
    list: {
      bg: value,
      '--popper-arrow-bg': value,
      color: 'white'
    },
    item: {
      _focus: {
        bg: mode('brand.300', 'brand.100')(props)
      },
      _active: {
        bg: mode('brand.100', 'whiteAlpha.200')(props)
      },
      _expanded: {
        bg: mode('brand.300', 'brand.100')(props)
      }
    }
  };
};

var variantOutline = props => {
  var value = getCSSVar(props.theme, 'colors', 'white');
  return {
    arrow: {
      bg: value
    },
    list: {
      bg: value,
      '--popper-arrow-bg': value,
      color: 'black'
    },
    item: {
      _focus: {
        bg: mode('gray.300', 'gray.100')(props)
      },
      _active: {
        bg: mode('gray.300', 'whiteAlpha.200')(props)
      },
      _expanded: {
        bg: mode('gray.300', 'gray.100')(props)
      }
    }
  };
};

var variantLight = props => {
  var value = getCSSVar(props.theme, 'colors', 'white');
  return {
    arrow: {
      bg: value
    },
    list: {
      bg: 'white',
      '--popper-arrow-bg': value,
      color: 'black'
    },
    item: {
      color: 'brand.500',
      _focus: {
        bg: mode('brand.300', 'brand.500')(props),
        color: 'white'
      },
      _hover: {
        bg: mode('gray.300', 'gray.100')(props),
        color: 'black'
      },
      _active: {
        bg: mode('gray.300', 'brand.300')(props),
        color: 'white'
      },
      _expanded: {
        bg: mode('gray.300', 'brand.500')(props),
        color: 'white'
      }
    }
  };
};

var baseStyleList = props => {
  return {
    boxShadow: mode('sm', 'dark-lg')(props),
    zIndex: 1,
    border: 0,
    borderWidth: 0,
    _focus: {
      boxShadow: 'none'
    }
  };
};

var baseStyleItem = () => {
  return {
    py: '0.4rem',
    px: '0.8rem',
    transitionProperty: 'background',
    transitionDuration: 'ultra-fast',
    transitionTimingFunction: 'ease-in',
    outline: 0,
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed'
    }
  };
};

var baseStyleArrow = () => {
  return {
    '--popper-arrow-size': '8px'
  };
};

var variants = {
  default: variantDefault,
  light: variantLight,
  outline: variantOutline
};

var baseStyle = props => ({
  arrow: baseStyleArrow(props),
  list: baseStyleList(props),
  item: baseStyleItem(props)
});

var defaultProps = {
  variant: 'default'
};
export default {
  parts: parts.keys,
  baseStyle,
  defaultProps,
  variants
};
//# sourceMappingURL=Menu.js.map